import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { store } from './redux/store';

import routes from './routes';

import { ThemeProvider } from './contexts/ThemeContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { LayoutProvider } from './contexts/LayoutContext';
import ChartJsDefaults from './utils/ChartJsDefaults';

import { AuthProvider } from './contexts/JWTContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
// import { AuthProvider } from "./contexts/FirebaseAuthContext";
// import { AuthProvider } from "./contexts/Auth0Context";
// import { AuthProvider } from "./contexts/CognitoContext";
import { GOOGLE_PLACE_API_KEY } from './config';
const App = () => {
  const content = useRoutes(routes);

  // useEffect(()=>{
  //   if (!("Notification" in window)) {
  //     //console.log("Browser does not support desktop notification");
  //   } else {
  //     Notification.requestPermission();
  //   }
  // },[]);

  return (
    <HelmetProvider>
      <Helmet titleTemplate='%s | Disputely - Credit Repair Done For You' defaultTitle='Disputely - Credit Repair Done For You'>
      <script src={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_PLACE_API_KEY}&libraries=places`}></script>
      <script>
          {`window.fwSettings={
          'widget_id':150000002784
          };
          !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()`}
      </script>
      <script type='text/javascript' src='https://widget.freshworks.com/widgets/150000002784.js' async defer></script>

      </Helmet>
      <Provider store={store}>
        <ThemeProvider>
          <SidebarProvider>
            <LayoutProvider>
              <ChartJsDefaults />
              <GoogleOAuthProvider clientId='595001593620-qrmp9a610sopvn7h86v2betqequd2cnk.apps.googleusercontent.com'>
                <AuthProvider>{content}</AuthProvider>
              </GoogleOAuthProvider>
            </LayoutProvider>
          </SidebarProvider>
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  );
};

export default App;
